const PlanTable = ({ vehicle, children }) => (
  <div className="priceTable">{children}</div>
);

export default PlanTable;
